// Enum'ы Charon (на проводе — числа, 0-based) с русскими подписями.
// Источник: plans/api_doc.md, таблица enum'ов.

export const Method = {
  0: 'Карта',
  1: 'QR',
  2: 'Гостевой QR',
  3: 'Лицо',
  4: 'Пин'
}

export const SkudScreen = {
  0: 'Успех',
  1: 'Отказ',
  2: 'Просрочен',
  3: 'Опоздание',
  4: 'Ранний уход',
  5: 'Повторный вход',
  6: 'Повторный выход',
  7: 'Сопровождение',
  8: 'День рождения',
  9: 'Тревога',
  10: 'Тревожный выход',
  11: 'Обслуживание'
}

export const PointDirection = {
  0: 'Вход',
  1: 'Выход'
}

export const PassageDirection = {
  0: 'Вход',
  1: 'Выход'
}

export const DirectionSource = {
  0: 'Конфиг',
  1: 'Авто',
  2: 'Вручную'
}

export const SubjectState = {
  0: 'Активен',
  1: 'Заблокирован',
  2: 'В архиве'
}

export const CredentialKind = {
  0: 'Карта',
  1: 'QR',
  2: 'Лицо',
  3: 'Пин',
  4: 'Мобильный'
}

export const CredentialIssuer = {
  0: 'БРСК',
  1: 'Локальный',
  2: 'Импорт',
  3: 'API'
}

export const CredentialState = {
  0: 'Активна',
  1: 'Заменена',
  2: 'Заблокирована'
}

export const GrantState = {
  0: 'Активен',
  1: 'Отозван'
}

export const GrantType = {
  0: 'Постоянный',
  1: 'Временный',
  2: 'Визит',
  3: 'Гость',
  4: 'Мастер'
}

export const PassageResult = {
  0: 'Разрешён',
  1: 'Отказ'
}

export const GuestPassState = {
  0: 'Активен',
  1: 'Использован',
  2: 'Истёк',
  3: 'Отозван'
}

export const VisitState = {
  0: 'Черновик',
  1: 'Ожидает',
  2: 'Подтверждён',
  3: 'Отклонён',
  4: 'Активен',
  5: 'Завершён',
  6: 'Отменён'
}

export const VisitParticipantState = {
  0: 'Включён',
  1: 'Исключён'
}

export const PointCommandType = {
  0: 'Включить тревогу',
  1: 'Тревожный выход',
  2: 'Выключить тревогу',
  3: 'Включить обслуживание',
  4: 'Выключить обслуживание',
  5: 'Праздничный режим',
  6: 'Синхронизировать',
  7: 'Перечитать конфиг',
  8: 'Перезагрузить'
}

export const ConsumerTokenMode = {
  0: 'Чтение проходов'
}

export const ConsumerTokenSource = {
  0: 'Выдан',
  1: 'Начальный'
}

export const AuditAction = {
  0: 'Добавление',
  1: 'Изменение',
  2: 'Удаление'
}

// Число -> подпись; неизвестное значение возвращается как есть.
export function enumText (map, v) {
  const t = map[v]
  return t !== undefined ? t : v
}

// Мапа -> items для v-select: [{value: Number, text}].
export function enumOptions (map) {
  return Object.keys(map).map(k => ({ value: Number(k), text: map[k] }))
}

// Цвета чипов состояний.
export function visitStateColor (state) {
  switch (Number(state)) {
    case 0: return 'grey'
    case 1: return 'orange'
    case 2: return 'blue'
    case 3: return 'red'
    case 4: return 'green'
    case 5: return 'teal'
    case 6: return 'grey'
    default: return 'grey'
  }
}

export function grantStateColor (state) {
  return Number(state) === 0 ? 'green' : 'red'
}

export function guestStateColor (state) {
  switch (Number(state)) {
    case 0: return 'green'
    case 1: return 'blue'
    case 2: return 'orange'
    case 3: return 'red'
    default: return 'grey'
  }
}
